export default __webpack_public_path__ + "static/media/twitter 1.3fbda9a8.svg";